import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NuclearTopicsLabelService {
  constructor() {}

  getTopicLabels(): { [key: string]: string } {
    return {
      SPS: 'Sofferenza e Patologie',
      FAM: 'Famiglia',
      RA: 'Relazione Affettiva',
      OS: 'Occupazione/Studio',
      PRG: 'Progettualità',
      ET: 'Esperienza Terapeutica',
      MDE: 'Modi di Essere',
      RS: 'Rete Sociale',
      RCT: 'Rifigurazioni Terapeutiche',
      SES: 'Sessualità',
      BNS: 'Benessere',
      SV: 'Sistema Valoriale',
    };
  }
}
